import { Component, Input, OnInit } from '@angular/core';
import { TimeSlotTypes } from '../time-slot.component';
import { ApiService } from 'src/app/api/api.service';
import { ModalController } from '@ionic/angular';
import { GlobalService } from 'src/app/api/global.service';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-time-slot-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditComponent implements OnInit {

  TimeSlotTypes = TimeSlotTypes;
  typeOptions = [
    { value: TimeSlotTypes.appointment, label: 'Allow Appointments', description: 'Clients or staff can book appointments with you during this time. The system will not automatically assign work.' },
    { value: TimeSlotTypes.work, label: 'Allow Work', description: 'The system will be allowed to automatically assign work to you during this time period.' },
    { value: TimeSlotTypes.work_or_appointment, label: 'Allow Work or Appointments', description: 'The system can automatically assign work to you, and appointments can also be booked, during this time period.' }
  ];
  @Input() time_slot = {
    guid: '',
      title: '',
      description: '',
      day_of_week: 0,
      all_day: false,
      start_time: null,
      start_time_iso: '',
      end_time: null,
      end_time_iso: '',
      type: TimeSlotTypes.work_or_appointment
    }
    daysOfTheWeek: any = [
      {
        name: 'Sunday',
        value: 0
      },
      {
        name: 'Monday',
        value: 1
      },
      {
        name: 'Tuesday',
        value: 2
      },
      {
        name: 'Wednesday',
        value: 3
      },
      {
        name: 'Thursrday',
        value: 4
      },
      {
        name: 'Friday',
        value: 5
      },
      {
        name: 'Saturday',
        value: 6
      },
  
    ]
    old_start_time = '';
    old_end_time = '';

  constructor(private apiService: ApiService, private modalController: ModalController,public globalService: GlobalService) {
    
   }

  ngOnInit() {
    if(dayjs(this.time_slot.start_time).format('HH:mm') == dayjs().startOf('day').format('HH:mm') && dayjs(this.time_slot.end_time).format('HH:mm') == dayjs().endOf('day').format('HH:mm')){
      this.time_slot.all_day = true;
    }

  }
   async SetStartOfDay() {
      console.log(this.time_slot.all_day);
      if(this.time_slot.all_day) {
        this.old_start_time = this.time_slot.start_time.toISOString();
        this.old_end_time = this.time_slot.end_time.toISOString()
        this.time_slot.start_time = dayjs().startOf('day').toDate();
        this.time_slot.end_time = dayjs().endOf('day').toDate();
      } else{
        if(this.old_end_time != '') this.time_slot.end_time = dayjs(this.old_end_time).toDate();
        if(this.old_start_time != '') this.time_slot.start_time = dayjs(this.old_start_time).toDate();
      }
      
    }


  async Update() {
    this.time_slot.start_time_iso = this.time_slot.start_time.toISOString();
    this.time_slot.end_time_iso = this.time_slot.end_time.toISOString();
    (this.time_slot as any).tz_str = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let data: any = await this.apiService.put(`calendar/setup/${this.time_slot.guid}`,this.time_slot);
    this.globalService.presentToastMessage(data.message,data.success);
    if(data.success) this.modalController.dismiss();
  }

  async Close() {
    this.modalController.dismiss();
  }

  async Delete() {
    let data: any = await this.apiService.delete(`calendar/setup/${this.time_slot.guid}`,null);
    this.globalService.presentToastMessage(data.message,data.success);
    if(data.success) this.modalController.dismiss();
    this.modalController.dismiss();
  }

}
